import { render, staticRenderFns } from "./orderStatementPrint.vue?vue&type=template&id=61c59e67&"
import script from "./orderStatementPrint.vue?vue&type=script&lang=ts&"
export * from "./orderStatementPrint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports